<div class="contenedorDetalle">
  <div class="detalleHeader">
    <h2>
      Detalle Transportista: {{ transportista?.nombre }} 
    </h2>
    <!-- si queremos los 3 botones esta es la clase "displayFlex botonesDetalle"  -->
    <div class="displayFlex ">
      <div
        *ngIf="
          path !== '/cliente/transportista'
        "
      >
        <button (click)="disableInput()" *ngIf="role != 'user'">Editar</button>
      </div>
    <!--  <button class="button__secondary">Imprimir</button>
      <button class="button__secondary">Descarga</button> -->
    </div>
  </div>
  <div>
    <form
      novalidate
      [formGroup]="detalleTransportista"
      class="detalleTransportista"
    >
      <div>
        <h3>Datos del Transportista</h3>
        <div class="datos__detalle">
          <div>
            <ng-container *ngIf="path == '/contratista/estado/transportistas'">
              <label for="nombre">Denominación</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="nombre"
              id="nombre"
            />
            </ng-container>
            <ng-container *ngIf="path == '/cliente/transportista'">
              <label for="nombre">Denominación</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="nombre"
              id="nombre"
            />
            </ng-container>
            <ng-container *ngIf="path == '/inproeco/estado/transportistas'">
              <label for="nombre">Denominación</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nombre"
              id="nombre"
            />

            </ng-container>
            
          </div>

          <div>
            <ng-container *ngIf="path == '/contratista/estado/transportistas'">
              <label for="cif">CIF</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="cif"
              id="cif"
            />
            </ng-container>
            <ng-container *ngIf="path == '/cliente/transportista'">
              <label for="cif">CIF</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="cif"
              id="cif"
            />
            </ng-container>
            <ng-container *ngIf="path == '/inproeco/estado/transportistas'">
              <label for="cif">CIF</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="cif"
              id="cif"
            />
            </ng-container>  
          </div>

          <div>
            <ng-container *ngIf="path == '/contratista/estado/transportistas'">
              <label for="codigo">Código</label>
              <input
                [attr.disabled]="disableInputBox ? true : false"
                type="text"
                formControlName="codigo"
                id="codigo"
              />
            </ng-container>
            <ng-container *ngIf="path == '/cliente/transportista'">
              <label for="codigo">Código</label>
              <input
                [attr.disabled]="disableInputBox ? true : false"
                type="text"
                formControlName="codigo"
                id="codigo"
              />
            </ng-container>
            <ng-container *ngIf="path == '/inproeco/estado/transportistas'">
              <label for="codigo">Código</label>
              <input
                [attr.disabled]="disableInputBox ? true : null"
                type="text"
                formControlName="codigo"
                id="codigo"
              />

            </ng-container>
          </div>

          <div>
            <ng-container *ngIf="path == '/contratista/estado/transportistas'">
              <label for="nima">NIMA</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="nima"
              id="nima"
            />
            </ng-container>
            <ng-container *ngIf="path == '/cliente/transportista'">
              <label for="nima">NIMA</label>
            <input
              [attr.disabled]="disableInputBox ? true : false"
              type="text"
              formControlName="nima"
              id="nima"
            />
            </ng-container>
            <ng-container *ngIf="path == '/inproeco/estado/transportistas'">
              <label for="nima">NIMA</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nima"
              id="nima"
            />
            </ng-container>
          </div>
        </div>
        <div formGroupName="contacto" *ngIf="path === '/contratista/estado/transportistas'">
        <h3>Datos de contacto</h3>
        <div class="datos__detalle">
          <div>
            <label for="nombre">Persona de Contacto</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nombre"
              id="nombre"
            />
          </div>
          <div>
            <label for="mail">Mail de Contacto</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="mail"
              id="mail"
            />
          </div>
        </div>
      </div>
        <div *ngIf="!disableInputBox">
          <button [mat-dialog-close] (click)="updateTransportistaById()">Guardar</button>
        </div>
      </div>
    </form>
    <div *ngIf="path === '/cliente/transportista'">
      <h3>Documentos Obligatorios del Transportista</h3>
      <div class="displayFlex documentos" >
        <div class="displayFlexVertical" *ngFor="let documento of documentosVista">
         <!--  <div *ngIf="!documento.validado">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
          </div> -->
          <div *ngIf="(documento?.enFecha || documento?.noCaduca) && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/validado.svg"
            #tooltip="matTooltip"  matTooltip="Validado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/proximo-a-caducar.svg" 
            #tooltip="matTooltip"  matTooltip="Próximo a caducar" matTooltipPosition="left"/>
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/caducado.svg"
            #tooltip="matTooltip"  matTooltip="Caducado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper" >
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/verde.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div> 
          <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper" >
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/rojo.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div> 
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
            <img (click)= "openDocumento(documento.id)" class="documento__circulo" src="../../../../../assets/Amarillo.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <ng-container *ngIf="documento.validado">
          <p>{{documento.nombre}}</p>
          <p>{{documento.fechaValidez | date: 'dd/MM/yyyy'}}</p>
          <div *ngIf="documento.fechaCaducidad">
          <p>{{documento.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div *ngIf="!documento.fechaCaducidad">
          <p>No caduca</p>
        </div>
      </ng-container>
        </div>
      </div>
      </div>

    <div *ngIf="path === '/contratista/estado/transportistas'">
      <h3>Documentos Obligatorios del Transportista</h3>
      <div class="displayFlex documentos" >
        <div class="displayFlexVertical" *ngFor="let documento of documentosVista">
          <div *ngIf="!documento.validado">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/validado.svg"
            #tooltip="matTooltip"  matTooltip="Validado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/proximo-a-caducar.svg" 
            #tooltip="matTooltip"  matTooltip="Próximo a caducar" matTooltipPosition="left"/>
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'activo'">
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/caducado.svg"
            #tooltip="matTooltip"  matTooltip="Caducado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper" >
            <img  (click)= "openDocumento(documento.id)" src="../../../../../assets/verde.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div> 
          <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper" >
            <img (click)= "openDocumento(documento.id)" src="../../../../../assets/rojo.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div> 
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
            <img class="documento__circulo" (click)= "openDocumento(documento.id)" src="../../../../../assets/Amarillo.png" 
            #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <p>{{documento.nombre}}</p>
          <p>{{documento.fechaValidez | date: 'dd/MM/yyyy'}}</p>
          <div *ngIf="documento.fechaCaducidad">
          <p>{{documento.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div *ngIf="!documento.fechaCaducidad">
          <p>No caduca</p>
        </div>
        </div>
        <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado1?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo" >
            <button
              type="submit"
              id="auth1"
              (click)="openDetails(transportista.id, $event)"
            >
              Añadir Autorización 1
            </button>
          </div>
        </div>
          <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado2?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo" >
            <button
              type="submit"
              id="auth2"
              (click)="openDetails(transportista.id, $event)"
            >
              Añadir Autorización 2
            </button>
          </div>
        </div>
        <div class="displayFlexVertical botones"  *ngIf="documentoSeleccionado3?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo" >
            <button
            type="submit"
            id="auth3"
            (click)="openDetails(transportista.id, $event)"
            >
              Añadir Autorización 3
            </button>
          </div>
        </div>
        <div class="displayFlexVertical botones"  *ngIf="documentoSeleccionado4?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo" >
            <button
            type="submit"
            id="auth4"
            (click)="openDetails(transportista.id, $event)"
            >
              Añadir Autorización 4
            </button>
          </div>
        </div>
        <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado5?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo" >
            <button
              type="submit"
              id="auth5"
              (click)="openDetails(transportista.id, $event)"
            >
              Añadir Autorización 5
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- enlaces a tablas de pendiendo de los portales -->
    <!-- portal contratista -->
    <div class="displayFlexColumn"  *ngIf="path === '/contratista/estado/transportistas'">
      <a [routerLink]="['/contratista/estado/centros']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Centros
      </a>
      <ng-container *ngIf="userLog.contratista.xtensaBasica == 'false'">
      <a [routerLink]="['/contratista/estado/instalaciones']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Instalaciones
      </a>
      </ng-container>
    </div>
      <!-- portal cliente -->
    <div class="displayFlexColumn"  *ngIf="path === '/cliente/transportista'">
      <a [routerLink]="['cliente/centros']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Centros
      </a>
      <ng-container *ngIf="!userLog.cliente.xtensaBasica"> 
      <a [routerLink]="['cliente/instalaciones']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Instalaciones
      </a>
    </ng-container>   
    </div>
    <!-- portal inproeco -->
    <div class="displayFlexColumn"  *ngIf="path === '/inproeco/estado/transportistas'">
      <a [routerLink]="['inproeco/estado/centros']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Centros
      </a>
      <a [routerLink]="['inproeco/estado/instalaciones']" (click)="setIdTransportista(transportista.id)" [mat-dialog-close]>
        Ir a tabla Instalaciones
      </a>
    </div>
    <div>
      <h3>Contratistas</h3>
      <div
        *ngIf="transportista?.contratistas?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let contratista of transportista?.contratistas">
          <p class="contratistas">{{ contratista?.nombreComercial }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
  </div>
</div>
